import { render, staticRenderFns } from "./addCouponPage.vue?vue&type=template&id=48e0ba55&scoped=true"
import script from "./addCouponPage.vue?vue&type=script&lang=js"
export * from "./addCouponPage.vue?vue&type=script&lang=js"
import style0 from "./addCouponPage.vue?vue&type=style&index=0&id=48e0ba55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e0ba55",
  null
  
)

component.options.__file = "addCouponPage.vue"
export default component.exports